import styled from "styled-components";
import { pxToRem } from "../../../styles/utils";

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background: #fff;
  border-radius: ${pxToRem(16)};
  box-shadow: 0 ${pxToRem(4)} ${pxToRem(12)} rgba(0, 0, 0, 0.1);
  width: ${pxToRem(429)};
  background: rgb(255, 255, 255);
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 ${pxToRem(30)};

  h2 {
    color: rgb(31, 10, 53);
    font-size: ${pxToRem(28)};
    font-weight: 700;
  }
`;

export const Divider = styled.div`
  width: 100%;
  height: ${pxToRem(1)};
  background-color: rgb(225, 224, 229);
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  width: ${pxToRem(24)};
  height: ${pxToRem(24)};
  font-size: ${pxToRem(24)};
  color: #ccc;
  cursor: pointer;

  &:hover {
    color: #000;
  }
`;

export const ModalBody = styled.div`
  p {
    color: rgb(185, 185, 185);
    font-size: ${pxToRem(18)};
    font-weight: 500;
    margin: ${pxToRem(30)} ${pxToRem(30)};
  }
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: space-between;
  gap: ${pxToRem(16)};
  margin: ${pxToRem(30)} ${pxToRem(30)} ${pxToRem(30)} ${pxToRem(30)};

  button {
    flex: 1;
  }
`;

export const AgreementLinks = styled.div`
  margin: ${pxToRem(20)} ${pxToRem(30)};
  display: flex;
  flex-direction: column;
  gap: ${pxToRem(10)};
`;

export const AgreementLink = styled.a`
  color: rgb(114, 82, 220);
  font-size: ${pxToRem(16)};
  text-decoration: none;
  transition: color 0.2s ease;

  &:hover {
    color: #603cbc;
  }
`;
